import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./UpdatePassword.css";
import Preloader from "../../../Preloader/Preloader";
import {
  getUsersSummary,
  changeUserPassword,
  getUserById,
} from "../../../../api/api";
import { useNavigate } from "react-router-dom";
import eyeHide from "../../../../images/eye-hide.svg";
import eyeShow from "../../../../images/eye-show.svg";

function UpdatePassword() {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [inputErrors, setInputErrors] = useState([]);
  const navigate = useNavigate();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersData = await getUsersSummary({ pageSize: 1000 });
        console.log("Полученные данные пользователей:", usersData);
        if (usersData && usersData.users) {
          setUsers(usersData.users);
          console.log("Список пользователей:", usersData.users);
        } else {
          console.error(
            "Получены некорректные данные пользователей:",
            usersData
          );
          setUsers([]);
        }
      } catch (error) {
        console.error("Ошибка при загрузке пользователей:", error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (formData.newPassword !== formData.confirmPassword) {
      setInputErrors((prevErrors) => {
        const newErrors = [...prevErrors];
        if (!newErrors.includes("Пароли не совпадают")) {
          newErrors.push("Пароли не совпадают");
        }
        return newErrors;
      });
    } else {
      setInputErrors((prevErrors) =>
        prevErrors.filter((error) => error !== "Пароли не совпадают")
      );
    }
  }, [formData.newPassword, formData.confirmPassword]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      border: "1px solid #E0E0E0",
      padding: "5px",
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 300,
      lineHeight: "19.12px",
    }),
    menu: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      marginTop: "5px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 300,
    }),
  };

  const handleUserChange = async (selectedOption) => {
    console.log("Выбранный пользователь:", selectedOption);
    setSelectedUser(selectedOption);
    setFormData({ newPassword: "", confirmPassword: "" });
    setInputErrors([]);

    if (selectedOption) {
      try {
        console.log(
          "Запрашиваем данные пользователя для ID:",
          selectedOption.value
        );
        const userData = await getUserById(selectedOption.value);
        console.log("Полученные данные пользователя:", userData);

        // Проверяем структуру данных
        if (userData && userData.users && userData.users.length > 0) {
          const user = userData;
          console.log("Данные пользователя из массива:", user);
          if (user.username) {
            console.log("Устанавливаем username:", user.username);
            setSelectedUser((prev) => ({
              ...prev,
              username: user.username,
            }));
          } else {
            console.error("Username не найден в данных пользователя");
          }
        } else {
          console.error("Неверный формат данных пользователя:", userData);
        }
      } catch (error) {
        console.error("Ошибка при получении данных пользователя:", error);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleKeyPress = (e, fieldName) => {
    const char = String.fromCharCode(e.which);
    const pattern = /^[A-Za-z0-9@._-]+$/;
    if (!pattern.test(char)) {
      e.preventDefault();
      setInputErrors((prevErrors) => {
        const newErrors = [...prevErrors];
        if (
          !newErrors.includes(
            `Поле ${fieldName} должно содержать только латиницу, цифры и символы @._-`
          )
        ) {
          newErrors.push(
            `Поле ${fieldName} должно содержать только латиницу, цифры и символы @._-`
          );
        }
        return newErrors;
      });
    } else {
      setInputErrors((prevErrors) =>
        prevErrors.filter((error) => !error.includes(`Поле ${fieldName}`))
      );
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const validateForm = () => {
    const errors = [];
    if (formData.newPassword.length < 8) {
      errors.push("Новый пароль должен содержать не менее 8 символов");
    }
    if (formData.newPassword !== formData.confirmPassword) {
      errors.push("Пароли не совпадают");
    }
    setInputErrors(errors);
    return errors.length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      console.log("Данные пользователя перед сменой пароля:", {
        userId: selectedUser.value,
        username: selectedUser.username,
        newPassword: formData.newPassword,
      });

      await changeUserPassword(
        selectedUser.value,
        selectedUser.username,
        formData.newPassword
      );
      setShowSuccessPopup(true);
      setTimeout(() => {
        setShowSuccessPopup(false);
        navigate("../users");
      }, 3000);
    } catch (error) {
      console.error("Ошибка при изменении пароля:", error);
      setInputErrors(["Произошла ошибка при изменении пароля"]);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ newPassword: "", confirmPassword: "" });
    setInputErrors([]);
  };

  const isFormValid = () => {
    return (
      selectedUser &&
      formData.newPassword.length >= 8 &&
      formData.newPassword === formData.confirmPassword &&
      inputErrors.length === 0
    );
  };

  if (loading) {
    return <Preloader />;
  }

  const userOptions = users.map((user) => {
    const option = {
      value: user.id,
      label: `${user.name} ${user.surname}`,
      username: user.username,
    };
    console.log("Создана опция пользователя:", option);
    return option;
  });

  return (
    <div className="registration">
      <form className="registration__form" onSubmit={handleSubmit}>
        <ul className="registration__inputs">
          <li className="registration__inputs-container registration__inputs-container--full-width">
            <label className="registration__label">Выберите сотрудника</label>
            <Select
              options={userOptions}
              onChange={handleUserChange}
              value={selectedUser}
              placeholder="Выберите сотрудника"
              styles={customStyles}
            />
          </li>
        </ul>

        {selectedUser && (
          <ul className="registration__inputs">
            <li className="registration__inputs-container">
              <label className="registration__label">Новый пароль</label>
              <div className="password-input-container">
                <input
                  className="registration__input"
                  type={showPassword.newPassword ? "text" : "password"}
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleInputChange}
                  onKeyPress={(e) => handleKeyPress(e, "Новый пароль")}
                />
                <button
                  type="button"
                  className="password-toggle-button"
                  onClick={() => togglePasswordVisibility("newPassword")}
                >
                  <img
                    src={showPassword.newPassword ? eyeShow : eyeHide}
                    alt="toggle password visibility"
                    className="password-toggle-img"
                  />
                </button>
              </div>
            </li>
            <li className="registration__inputs-container">
              <label className="registration__label">Повторите пароль</label>
              <div className="password-input-container">
                <input
                  className="registration__input"
                  type={showPassword.confirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  onKeyPress={(e) => handleKeyPress(e, "Повторите пароль")}
                />
                <button
                  type="button"
                  className="password-toggle-button"
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                >
                  <img
                    src={showPassword.confirmPassword ? eyeShow : eyeHide}
                    alt="toggle password visibility"
                    className="password-toggle-img"
                  />
                </button>
              </div>
            </li>
            <li className="registration__inputs-container">
              <div className="registration__buttons">
                <button
                  type="submit"
                  className={`newreport__button button-send ${
                    isFormValid() ? "button-active" : "button-disabled"
                  }`}
                  disabled={!isFormValid()}
                >
                  Сохранить изменения
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="newreport__button button-reset"
                >
                  Сбросить
                </button>
              </div>
            </li>
          </ul>
        )}

        {inputErrors.length > 0 && (
          <div className="error-messages">
            {inputErrors.map((error, index) => (
              <p key={index} className="error-message">
                {error}
              </p>
            ))}
          </div>
        )}

        {showSuccessPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <div className="popup-icon"></div>
              <p className="popup-text">Пароль успешно изменен</p>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default UpdatePassword;
